import { Instagram, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/brand";

// Owner-supplied job photos from @mhjprestigetransport
const TILES = [
  "https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/3n3iv3ni_Screenshot_20260609_112234_Gallery.jpg",
  "https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/t368qocj_Screenshot_20260609_112821_Gallery.jpg",
  "https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/5qdx1f86_Screenshot_20260609_112831_Gallery.jpg",
  "https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/gwof54c1_Screenshot_20260609_112326_Gallery.jpg",
  "https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/ov00azs8_Screenshot_20260609_113112_Gallery.jpg",
];

export default function InstaShowcase() {
  return (
    <section
      id="work"
      data-testid="insta-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-6">
              <span className="w-8 h-px bg-[#E60000]" />
              Recent work · 06
            </div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.0]">
              See it on
              <br />
              <span className="text-zinc-500">@{BRAND.instagram}</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-zinc-400 text-base lg:text-lg leading-relaxed">
              We post every job — supercars on the trailer, late-night
              recoveries, cross-channel runs. Follow along for the daily feed.
            </p>
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="insta-follow-button"
              className="btn-primary mt-6"
            >
              <Instagram className="w-5 h-5" />
              Follow @{BRAND.instagram}
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <a
          href={BRAND.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block group"
          data-testid="insta-grid-link"
        >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
            {TILES.map((src, i) => (
              <div
                key={i}
                data-testid={`insta-tile-${i}`}
                className="relative aspect-square overflow-hidden bg-black"
              >
                <img
                  src={src}
                  alt={`MHJ Prestige Transport recent work ${i + 1}`}
                  className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <Instagram className="w-4 h-4" />
                  <ArrowUpRight className="w-4 h-4" />
                </div>
              </div>
            ))}
          </div>
        </a>

        <p className="text-xs text-zinc-600 mt-6 max-w-2xl">
          Recent jobs from <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer" className="underline hover:text-white">@{BRAND.instagram}</a>.
        </p>
      </div>
    </section>
  );
}
